import CostHTMLPreviewBaseSection from './CostHTMLPreviewBaseSection'

export default function CostHTMLPreviewGeneralCostsSection() {}

CostHTMLPreviewGeneralCostsSection.prototype = new CostHTMLPreviewBaseSection();

CostHTMLPreviewGeneralCostsSection.prototype.init = function( showLeaveTime, showOvertimeAddition, columnsStrategy )
{
    CostHTMLPreviewBaseSection.prototype.init.call( this, columnsStrategy );
    this.showLeaveTime = showLeaveTime;
    this.showOvertimeAddition = showOvertimeAddition;
    return this;
};

CostHTMLPreviewGeneralCostsSection.prototype.addRows = function( tBody )
{
    var headerRow = this.createRow("generalCosts");
    this.addCell( headerRow, this.message( "report.general_costs" ), "", this.columnsStrategy.getDataColumnsCount() + 1 );
    this.addRow( tBody, headerRow );

    if( this.showLeaveTime )
    {
        this.addRowWithMainCell( tBody, this.message( "report.cost.total_for_leave" ), "totalLeaveTimeCell", "totalLeaveTime" );
        for( var i = 0; i < 2; i++ )
            this.addRowWithMainCell( tBody, this.message( "leave_type.leave_type" ), "leaveType" );
    }

    if( this.showOvertimeAddition )
        this.addRowWithMainCell( tBody, this.message( "report.cost.overtime_bonus" ), "overtimeAdditionCell", "overtimeAddition" );
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/cost/CostHTMLPreviewGeneralCostsSection.js